import { render, staticRenderFns } from "./EcommerceOrderChart.vue?vue&type=template&id=bf367a88&"
import script from "./EcommerceOrderChart.vue?vue&type=script&lang=js&"
export * from "./EcommerceOrderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf367a88')) {
      api.createRecord('bf367a88', component.options)
    } else {
      api.reload('bf367a88', component.options)
    }
    module.hot.accept("./EcommerceOrderChart.vue?vue&type=template&id=bf367a88&", function () {
      api.rerender('bf367a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/EcommerceOrderChart.vue"
export default component.exports